module.exports = __webpack_public_path__ + "img/flag_of_denmark.67bc1688.svg";